import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const createRelevanceTestRun = async (
    {
        accessToken,
        testDefinitionId,
        options,
        signal,
    }: App.RelevanceTestRuns.CreateMutationVariables,
): Promise<Models.IngestConfigApi.RelevanceTests.RelevanceTestRun> => RelevanceTestsService
    .runRelevanceTest(
        accessToken,
        testDefinitionId,
        options,
        signal,
    );
